import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Program } from '../../models';

@Component({
    selector: 'app-program-card',
    templateUrl: './program-card.component.html',
    styleUrls: ['./program-card.component.scss'],
    standalone: false
})
export class ProgramCardComponent {
    @Input()
    program!: Program;

    @Output() updateSelectedPrograms: EventEmitter<any> = new EventEmitter();

    toggle: boolean = false;

    programCardClick() {
        // add/remove to selectedPrograms in program-card-collection
        this.updateSelectedPrograms.emit(this.program);

        this.toggle = !this.toggle;
    }
}
